import { createSlice } from "@reduxjs/toolkit";
import { getFeelingByUserId } from "../actions/feelingAction";

const initialState = {
    isLoading: false,
    data: {},
    isError: null,
};
export const feelingSlice = createSlice({
    name: "feeling",
    initialState,
    reducers: {
        resetFeelingState: (state) => {
            state.isLoading = false;
            state.data = {};
            state.isError = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getFeelingByUserId.pending, (state) => {
            state.isLoading = true;
        });
        builder.addCase(getFeelingByUserId.fulfilled, (state, { payload }) => {
            state.isLoading = false;
            state.data = payload;
        });
        builder.addCase(getFeelingByUserId.rejected, (state, { error }) => {
            state.isError = error;
        });
    },
});
export const { resetFeelingState } = feelingSlice.actions;
export default feelingSlice.reducer;
